module.exports = __webpack_public_path__ + "img/logo-mark.3bbd34e8.png";